// extracted by mini-css-extract-plugin
export default {"pre":"DualFontText_pre__2sxy+","medium":"DualFontText_medium__m7u5P","large":"DualFontText_large__ey+i3","post":"DualFontText_post__XOygp"};